/* tslint:disable */
export enum PaymentType {
    Base = 1,
    Bonus = 2,
    Deduction = 3,
    Cost = 4
  }